'use strict';

var _ = require('lodash');
var FilterDataAtTransformerUsingSearchRulesService = function FilterDataAtTransformerUsingSearchRulesService(currentStateCriteriaService) {
  function isExclusionTypeOperator(rule) {
    return rule.operator === '!=';
  }
  function checkCondition(entry, rule) {
    if (_.isNil(rule.value)) {
      return false;
    }
    if (!isExclusionTypeOperator(rule)) {
      return rule.value.indexOf(entry[rule.criterion]) !== -1;
    } else {
      return rule.value.indexOf(entry[rule.criterion]) === -1;
    }
  }
  function or(previous, current) {
    return previous || current;
  }
  function and(previous, current) {
    return previous && current;
  }
  function orFilter(entry, orRules) {
    var orFilterResult = false;
    orRules.forEach(function (rule) {
      orFilterResult = or(orFilterResult, checkCondition(entry, rule));
    });
    return orFilterResult;
  }
  function andFilter(entry, andRules) {
    var andFilterResult = true;
    andRules.forEach(function (rule) {
      andFilterResult = and(andFilterResult, checkCondition(entry, rule));
    });
    return andFilterResult;
  }
  function isFulfillingSearchRules(entry, categoryRules) {
    var filterResult = true;
    for (var i = 0; i < categoryRules.length; i++) {
      var categoryRule = categoryRules[i];
      var orFilterResult = true;
      var andFilterResult = true;
      if (categoryRule.orRules.length > 0) {
        orFilterResult = orFilter(entry, categoryRule.orRules);
      }
      if (categoryRule.andRules.length > 0) {
        andFilterResult = andFilter(entry, categoryRule.andRules);
      }
      filterResult = filterResult && orFilterResult && andFilterResult;
    }
    return filterResult;
  }
  var criterionToFieldNameMap = {
    Market: 'market',
    Cabin: 'cabin',
    POS: 'spos'
  };
  var prepareFilterRulesFunc = function prepareFilterRulesFunc(result, rule) {
    if (rule.criterion === 'Market' || rule.criterion === 'POS' || rule.criterion === 'Cabin') {
      result.push({
        category: rule.category,
        criterion: criterionToFieldNameMap[rule.criterion],
        value: rule.leftOperand,
        operator: rule.operator
      });
    }
  };
  function prepareFilterRules() {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var filterRules = _.transform(searchCriteria.rules, prepareFilterRulesFunc, []);
    var groupedFilters = _.groupBy(filterRules, 'category');
    var result = _.transform(groupedFilters, function (result, rules, metaCategory) {
      var andOrRules = _.partition(rules, isExclusionTypeOperator);
      result[metaCategory] = {
        andRules: andOrRules[0],
        orRules: andOrRules[1]
      };
      return result;
    }, {});
    return _.values(result);
  }
  return {
    isFulfillingSearchRules: isFulfillingSearchRules,
    prepareFilterRules: prepareFilterRules
  };
};
FilterDataAtTransformerUsingSearchRulesService.$inject = ['CurrentStateCriteriaService'];
module.exports = FilterDataAtTransformerUsingSearchRulesService;